export const couponItems = [
  { id: 1, discount: '20%', applies_on: '100 (EGP)', validity: '2 Month/s' },
  { id: 2, discount: '20%', applies_on: 'All Tickets', validity: '3 Month/s' },
  { id: 3, discount: '20%', applies_on: 'All Tickets', validity: '1 Month/s' },
  { id: 4, discount: '20%', applies_on: 'All Tickets', validity: '2 Month/s' },
  { id: 5, discount: '20%', applies_on: 'All Promotions', validity: '5 Month/s' },
  { id: 6, discount: '20%', applies_on: 'All Promotions', validity: '4 Month/s' },
  { id: 7, discount: '20%', applies_on: 'All Promotions', validity: '2 Month/s' }
]
